export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 37